import { render } from "./AllTrainingsView.vue?vue&type=template&id=7e7355c2"
import script from "./AllTrainingsView.vue?vue&type=script&lang=js"
export * from "./AllTrainingsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__